import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TimesPipe } from '../../pipe/TimesPipe';

@Component({
  selector: 'app-common-skeleton',
  standalone: true,
  imports: [CommonModule, TimesPipe],
  templateUrl: './common-skeleton.component.html',
  styleUrls: ['./common-skeleton.component.scss']
})
export class CommonSkeletonComponent implements OnInit {
  @Input() NameOftheScreen: string;
  @Input() countforView: number = 2;

  constructor() { }

  ngOnInit() {

   }

   arr: any = [{},{}]
   getRows(): number[] {
    const totalCards = Math.ceil(this.countforView / 3);
    return Array(totalCards).fill(0).map((x, i) => i);
  }

  // messageConversation: countforView = number of incoming/outgoing bubble
  // PAIRS. Callers pass it explicitly (message-widget: embedded ? 2 : 3).
  get conversationPairs(): number[] {
    return Array.from({ length: this.countforView }, (_, i) => i);
  }
  skeletonArray = Array.from({ length: 8 }, (_, i) => i + 1); // Creates 8 skeletons

  getMessageWidth(index: number): number {
    // Randomize message bubble width to look realistic
    const widths = [120, 150, 180, 200, 160, 140, 190, 170];
    return widths[index % widths.length];
  }


}
